import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import {
  Page,
  Link,
  Logo,
} from 'components';
import { useBreakpoint, useWindowDimensions } from 'hooks';
import { BUILD_VERSION } from 'settings';
import { getSettings } from 'utils/settings';

import useStyles from './styles';

function LayoutAuth({ children }) {
  const classes = useStyles();
  const { height, width } = useWindowDimensions();
  const isMobile = ['sm', 'xs'].includes(useBreakpoint());
  const companyWaves = getSettings('site.waves');
  const configWidth = getSettings('logo.width');

  return (
    <div className={classes.root}>
      <Page maxWidth="lg" className={classes.bg}>
        <div className={classes.bgFullHeight}>

          {!isMobile && <Box sx={{
            position: 'absolute',
            width: '23041.8px',
            height: '100vh',
            bottom: 0,
            left: 0,
            backgroundImage: `url(${companyWaves})`,
            backgroundRepeat: 'repeat-x',
            zIndex: 0,
          }} />}

          {(width > 1024 && height < 780) && (<div className={classes.back_footer} />)}

          <div className={classes.container_icons}>
            {function () {
              const elems = [];
              [
                {
                  size: 5,
                  value: '',
                },
                {
                  size: 8,
                  value: 'square_',
                },
              ].forEach(({ size, value }) => {
                for (let i = 1; i <= size; i++) {
                  elems.push(<div
                    className={classes[`icon_${value}${i}`]}
                  />);
                }
              });

              return elems;
            }()}
          </div>

          <Box
            alignItems="center"
            children={<Logo style={{
              maxHeight: configWidth ?? 38,
            }} variant='imagotipo' />}
            className={classes.header_imagotipo}
            display={isMobile ? undefined : 'flex'}
            mb={isMobile ? undefined : 8}
          />


          {!isMobile && (<Box
            alignItems="center"
            children={<Logo style={{
              maxHeight: 24,
            }} variant='imagotipo' />}
            className={classes.header_isotipo}
            display="flex"
            mb={8}
          />)}

          {children}

        </div>
      </Page>

      <footer className={classes.footer}>
        <Box lg={12} display="flex" alignItems="center" className={classes.footer_cont}>
          <div className={classes.footer_text}>
            <Typography
              children={`Versión ${BUILD_VERSION}`}
              style={{
                fontSize: '0.9rem',
                fontWeight: '500',
              }}
              variant="caption"
            />
          </div>
          <div className={classes.cont_policies}>
            <div className={classes.footer_text}>
              <Link to="https://pinpeo.com/terminos-y-condiciones.html" variant="external">
                <Typography
                  children="Términos y condiciones"
                  style={{
                    color: '#ffffff',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                  }}
                  variant="caption"
                />
              </Link>
            </div>
            <div className={classes.footer_text}>
              <Link to="https://pinpeo.com/aviso-de-privacidad.html" variant="external">
                <Typography
                  children="Aviso de privacidad"
                  style={{
                    color: '#ffffff',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                  }}
                  variant="caption"
                />
              </Link>
            </div>
          </div>
        </Box>
      </footer>

    </div>
  );
};

LayoutAuth.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default LayoutAuth;
